// About.js
import React, { Component } from 'react';
import axios from "axios";
// Amplify Service Integration 
import Amplify from 'aws-amplify';
// import 'bootstrap/dist/css/bootstrap.min.css';

class Dashboard extends Component {
  constructor(props, context) {
  super(props, context);
  this.state = {
      isLoading: true,
      name: null,
      username: "null",
      isAuthenticated: false,
      isAuthenticating: true,
      loginUsername: "identityId",
      frequencyChart: "https://www.spphotonic.com/img/prism.png",
      spectraImg: "https://www.spphotonic.com/img/prism.png",
      conductivityImg: "https://www.spphotonic.com/img/prism.png",
      dlsimage: "",
      colorsensorimage: "",
      latestCluster: "",
      latestClusterPie: ""
      }

  this.activateLaser = this.activateLaser.bind(this);


  }
  activateLaser()
  {
  console.log("Lasers Activated")
  }
async getSummary(user) {

  axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/MLSummaryFile.json')
    .then(response => {
        console.log(response.data);
        var people = []
        for (var i =0;i < response.data['PatientCount']; i++)
        {
          people.push({name: response.data['PatientRecord:'+i],
            index:i
          })
        }
        this.setState({
          devicesConfigured: response.data['DeviceCount'],
          testSubjectsEnrolled: response.data['PatientCount'],
          totalSampleScans: response.data['ScanCount'],
          lambdaMessage: response.data['Title'],
          patientArray: people

        });
        })
}
async getImage() {
  // const fileString = this.state.username + "/" + this.state.username + "-C.png"
  // console.log(fileString)
axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/cluster-hash1234.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          frequencyChart: image
        });      
    })
axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/conductivity_summary.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          conductivityImg: image
        });      
    })
axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/dls_summary.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          dlsimage: image
        });      
    })

axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/colorsensor_summary.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          colorsensorimage: image
        });      
    })


    // Amplify.Storage.list('', {level:'private', identityId: this.state.loginUsername}) // for listing ALL files without prefix, pass '' instead
    //     .then(result => console.log(result))
    //     .catch(err => console.log(err));
    Amplify.Storage.get('clusterdetail-0-ChemId.png', {level: 'private', identityId: this.state.loginUsername}) // the identityId of that user })
            .then(result => {
                    // console.log(result)
                    this.setState({ latestCluster: result
                                  })
                  })
            .catch(err => console.log(err)); // Gets welcome.png in public space

    Amplify.Storage.get('clusterdetail-0-PieChart.png', {level: 'private', identityId: this.state.loginUsername}) // the identityId of that user })
            .then(result => {
                    // console.log(result)
                    this.setState({ latestClusterPie: result
                                  })
                  })
            .catch(err => console.log(err)); // Gets welcome.png in public space


}

async componentDidMount() {
    Amplify.Auth.currentUserInfo()
      .then(data => {
        this.setState({
          username: data.username,
          loginUsername: data.id
        })
        console.log(data.username)
        console.log(data.id)
        this.getSummary(this)
        this.getImage(this)

        this.setState({ isAuthenticating: false })
      })
      .catch(err => console.log('error: ', err))

}


  buttonOnClick ()
  {

    // alert('Marketplace is not yet Available.');

  }



  render() {
    return (
    <div className="container">
    <h2>Welcome to SPPhotonic Dashboard</h2>

          <div className="row justify-content-center" style={{display:'flex'}}>
                <div className="col mr-6" >
                      <div><p>Welcome User: {this.state.username} </p><code> {this.state.loginUsername}</code></div>
                      <div><p>Devices Configured: <code> {this.state.devicesConfigured}</code></p></div>
                      <div><p>Test Subjects Enrolled: <code>{this.state.testSubjectsEnrolled}</code> </p></div>
                      <div><p>Total Sample Scans: <code>{this.state.totalSampleScans} </code> </p></div>
                      <div><p>Lambda Message:<code> {this.state.lambdaMessage} </code> </p></div> 
                    </div>

                <div className="col my-auto">
                  <img src={this.state.frequencyChart} style={{width:"400px"}} className="img-thumbnail" alt="clusterSummary2" />
                </div>
            </div>
            <br/>
            <div className="row justify-content-center" style={{display:'flex'}}>
                <div className="col-md-4" >
                <img src={this.state.dlsimage} style={{width:"360px"}} className="img-thumbnail" alt="dlsSummaryImage" />
                <p style={{width:"360px"}}>Dynamic Laser Scattering measures the Turbidity of the fluid sample.</p>
                </div>
                <div class="col-md-4">
                  <img src={this.state.conductivityImg} style={{width:"360px"}} className="img-thumbnail" alt="dlsSummaryImage" />
                  <p style={{width:"360px"}}>Electrolyte Concetration is proportional to the intensity of the conductivity of the fluid sample. 
                  The measurement is derived from the conductivity signal data.</p>
                  </div>
                <div className="col-md-4">
                  <img src={this.state.colorsensorimage} style={{width:"360px"}} className="img-thumbnail" alt="colorSensorSummaryImage" />
                  <p style={{width:"360px"}}>Color Sensor Measures the Light Absorption/ Transmission Characteristics of the Fluid Sample in the Visible Spectrum.</p>
                </div>
            </div>

            <div className="row justify-content-center my-3" style={{display:'flex'}}>
                <div className="col-md-3 my-auto" >
                        <img src={this.state.latestClusterPie} style={{width:"400px"}} className="img-thumbnail" alt="latestClusterPieChart" />
                </div>
                <div className="col-md-9">
                        <img src={this.state.latestCluster} style={{width:"800px"}} className="img-thumbnail" alt="latestClusterDetailImage" />
                              <p>Chemical Identification can help identify interesting particles in the Human Urine Waste. </p>

                </div>
            </div>








    
    <h3>© SPPhotonic Inc 2021</h3>
    </div>
    );
  }
}

export default Dashboard;